import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';

import { FaAngleLeft, FaAngleRight } from 'react-icons/fa'

import { Container } from './styles';
import api from '../../services/api';
import { useAuth } from '../../hooks/AuthContext'
import { useListChildren } from '../../hooks/ParentContext'
import { render } from '@testing-library/react';

const ChartCard = ({ name, line, route, labels }) => {
  const { user } = useAuth();
  const { selectedOne } = useListChildren();
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [period, setPeriod] = useState("day");

  const token = localStorage.getItem("@Ocariot:token");
  const [chartData, setChartData] = useState({})
  const [chartDates, setChartDates] = useState({})

  const [periodGap, setPeriodGap] = useState(0)

  // const [startDate, setStartDate] = useState()
  // const [endDate, setEndDate] = useState()

  const formatDate = (date) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getFullYear();
    date = yyyy + '-' + mm + '-' + dd
    return date;
  }

  const setDates = () => {
    let date = new Date()
    // setEndDate(formatDate(date));

    let endDateReq = new Date();
    let startDateReq = new Date();

    if (period === "day") {
      startDateReq.setDate(date.getDate() - 5 + periodGap)
      endDateReq.setDate(date.getDate() + periodGap)
    } else if (period === "week") {
      startDateReq.setDate(date.getDate() - (5 * 7) + (periodGap * (5 * 7)))
      endDateReq.setDate(date.getDate() + (5 * 7) * periodGap)
    } else if (period === "month") {
      startDateReq.setDate(date.getDate() - (5 * 7 * 5) + (periodGap * (5 * 7 * 5)))
      endDateReq.setDate(date.getDate() + (5 * 7 * 5) * periodGap)
    }
    startDateReq = formatDate(startDateReq)
    endDateReq = formatDate(endDateReq)
    // setStartDate(startDateReq)

    let dates = {
      stDate: startDateReq,
      enDate: endDateReq
    }

    return dates;
  }

  const getData = () => {

    // console.log('startDate', startDate);
    // console.log('startDateReq', startDateReq);

    let path = `statistics/${route}/${selectedOne._id}/${setDates().stDate}/${setDates().enDate}/`
    api.get(path, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        sort: period
      }
    }).then((res) => {
      // console.log(res);
      let chartData = {
        firstLabel: [],
        secondLabel: [],
        thirdLabel: [],
        fourthLabel: []
      }
      let chartDates = []

      if (route === "activity") {
        res.data.data.forEach((i) => {
          chartData.firstLabel.push(i.activeMinutes)
          chartData.secondLabel.push(i.caloriesOut)
          chartData.thirdLabel.push(i.sedentaryMinutes)
          chartData.fourthLabel.push(i.steps)

          if (period === "week") {
            let bDate = new Date(i.range.begin);
            let eDate = new Date(i.range.end);
            bDate.setDate(bDate.getDate() + 1)
            eDate.setDate(eDate.getDate() + 1)
            chartDates.push(("0" + bDate.getDate()).substr(-2) + '/' + ("0" + (bDate.getMonth() + 1)).substr(-2) + '-' + ("0" + eDate.getDate()).substr(-2) + '/' + ("0" + (eDate.getMonth() + 1)).substr(-2));
          } else if (period === "month") {
            const months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]
            chartDates.push(months[i.date.month - 1]);
          } else {
            chartDates.push(("0" + i.date.day).substr(-2) + '/' + ("0" + i.date.month).substr(-2) + '/' + ("0" + i.date.year).substr(-2))
          }
        })
      }

      if (route === "sleep") {
        res.data.data.forEach((i) => {
          chartData.firstLabel.push(i.deepMinutes)
          chartData.secondLabel.push(i.lightMinutes)
          chartData.thirdLabel.push(i.remMinutes)
          chartData.fourthLabel.push(i.wakeMinutes)

          chartDates.push(("0" + i.date.day).substr(-2) + '/' + ("0" + i.date.month).substr(-2) + '/' + ("0" + i.date.year).substr(-2))
        })
      }

      setChartData(chartData)
      setChartDates(chartDates)

      setSelectedLabels(chartDates)
    }).catch((err) => {
      console.log(err);
    });

  }

  const prev = () => {
    // getData();
    setPeriodGap(periodGap - 5)
  }
  const next = () => {
    setPeriodGap(periodGap + 5)
    // getData();
  }

  useEffect(() => {

    getData();
  }, [selectedOne, period, periodGap])

  return (
    <Container>
      <button className="button-left" onClick={() => prev()}>
        <FaAngleLeft size={20} />
      </button>
      <header>
        <strong>{name}</strong>
        <div className="period-container">
          <button
            onClick={() => setPeriod("day")}
            className={(period === "day") ? "active" : ""}
          >
            Dias
          </button>
          <button
            onClick={() => setPeriod("week")}
            className={(period === "week") ? "active" : ""}
          >
            Semanas
          </button>
          <button
            onClick={() => setPeriod("month")}
            className={(period === "month") ? "active" : ""}
          >
            Meses
          </button>
        </div>
      </header>
      <div className="line-chart">
        <Line
          options={{
            scales: {
              y: {
                min: 0
              }
            },
            responsive: true,
            plugins: {
              legend: {
                display: true,
                labels: {
                  boxWidth: 10,
                  boxHeight: 10,
                  borderRadius: '50%',
                }
              },
            },
            // animation: {
            //   duration: 1
            // }
          }}
          data={{
            labels: selectedLabels,
            datasets: [
              {
                label: [
                  labels[0],
                ],
                data: chartData.fourthLabel,
                fill: false,
                backgroundColor: 'rgb(75, 192, 192)',
                borderColor: 'rgb(75, 192, 192)',
                tension: 0.1
              },
              {
                label: [
                  labels[1],
                ],
                data: chartData.thirdLabel,
                fill: false,
                // hidden: true,
                backgroundColor: 'rgba(255, 99, 132, 1)',
                borderColor: 'rgba(255, 99, 132, 1)',
                tension: 0.1
              },
              {
                label: [
                  labels[2],
                ],
                data: chartData.firstLabel,
                fill: false,
                // hidden: true,
                backgroundColor: '#4CAF50',
                borderColor: '#4CAF50',
                tension: 0.1
              },
              {
                label: [
                  labels[3],
                ],
                data: chartData.secondLabel,
                fill: false,
                // hidden: true,
                backgroundColor: 'rgba(255, 206, 86, 1)',
                borderColor: 'rgba(255, 206, 86, 1)',
                tension: 0.1
              },
            ],
          }}
        />

      </div>
      <button className="button-right" onClick={() => next()}>
        <FaAngleRight size={20} />
      </button>
    </Container>
  );
}

export default ChartCard;